import { NzMessageService } from 'ng-zorro-antd/message';
import { MediaService } from '../../media.service';
import { LayoutService } from './../../../../layout/layout.service';
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad';
import * as g from 'src/app/globals';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.less'],
})
export class SignaturePadComponent implements OnInit {
  @Output() fileUploaded: EventEmitter<string> = new EventEmitter();
  @Input() saveToImage = false;
  @ViewChild(SignaturePad) signaturePad: SignaturePad;

  screenSize = '';
  isLoading = false;
  globals = g;
  acceptTerms = false;

  signaturePadOptions = {
    minWidth: 4,
    canvasWidth: 350,
    canvasHeight: 365,
  };

  constructor(
    private layoutService: LayoutService,
    private mediaService: MediaService,
    private messageService: NzMessageService
  ) {}
  ngOnInit(): void {
    this.screenSize = this.layoutService.screenSize;
    this.layoutService.screenSizeEmitter.subscribe((d) => {
      this.screenSize = this.layoutService.screenSize;
      this.setWidthBasedOnSize();
    });

    this.setWidthBasedOnSize();
  }

  setWidthBasedOnSize() {
    if (this.screenSize === 'x-small') {
      this.signaturePadOptions.canvasWidth = 290;
    } else if (this.screenSize === 'small') {
      this.signaturePadOptions.canvasWidth = 550;
    } else if (this.screenSize === 'medium') {
      this.signaturePadOptions.canvasWidth = 900;
    } else {
      this.signaturePadOptions.canvasWidth = 1200;
    }
  }

  clear() {
    this.signaturePad.clear();
  }

  drawComplete() {
    if (this.acceptTerms === false && g.showSignaturePadTermsAndCondition) {
      this.messageService.error(
        this.layoutService.translate(
          'Please accept terms and conditions first.'
        )
      );

      return;
    }

    if (this.signaturePad.isEmpty()) {
      this.messageService.error(
        this.layoutService.translate(
          'Please insert the signature before submitting.'
        )
      );
    } else {
      const data = this.signaturePad.toDataURL();
      this.isLoading = true;
      this.mediaService
        .submitData(data, 'signature', this.saveToImage)
        .subscribe((e: any) => {
          if (e.Has_Error) {
            this.messageService.error(e.Error_Message);
          } else {
            this.fileUploaded.emit(e.Resault_Value);
          }

          this.isLoading = false;
        });
    }
  }
}
